import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';

export const ZodLabelWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    text: z.string(),
});

export type LabelWidgetConfigurationDetails = z.infer<typeof ZodLabelWidgetConfigurationDetails>;

export const ZodLabelWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.LABEL),
    config: ZodLabelWidgetConfigurationDetails,
});

export type LabelWidgetConfiguration = z.infer<typeof ZodLabelWidgetConfiguration>;
